import { DetailOrderProduct } from 'types/forms/ProtocolOrdersFormProps';

export const productWithoutStock = (product: DetailOrderProduct): boolean => {
  if (!product.stock || product.stock <= 0) return true;
  return false;
};
